import PrivateRoute from "./Private";
import PublicRoute from "./Public";

const routes = { public: PublicRoute, private: PrivateRoute };

export default routes;
